import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Button, Card, ListGroup, ListGroupItem, ButtonGroup, Row, Col } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../Context/Auth/AuthContext';
import PSO from '../../../services/PSO';
import Strings from '../../../translations/Translations';
import { toast } from 'react-toastify';

export default function ListCampaignsModule () {
  const history = useHistory();
  const { toggleActiveCampaign, toggleCurrentCampaign, authenticated, toggleLoading } = useAuth();

  const [campaignsData, setCampaignsData] = useState();

  const [showLoadMore, setShowLoadMore] = useState(false);

  const getCollectionPars = useCallback(async (colid) => {
    let result = false;
    toggleLoading(true);

    try {
      const response = await PSO.getCollectionPars({
        un: authenticated.un,
        al: authenticated.al,
        colid
      });

      if (response.result === 'success' && response.its && response.its.length > 0) {
        result = response.its[0];
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }
    } catch (err) {
      toast.error(Strings('general_error'));
    }

    toggleLoading(false);
    return result;
  }, [authenticated, toggleLoading]);

  const goToCampaign = useCallback(async (item) => {
    if (item && item.colid) {
      const collectionPars = await getCollectionPars(item.colid);
      if (collectionPars) {
        toggleCurrentCampaign(collectionPars);
        history.replace('/campaign');
        toggleActiveCampaign(true);
      }
    }
  }, [history, toggleActiveCampaign, toggleCurrentCampaign, getCollectionPars]);

  const getCollections = useCallback(async () => {
    toggleLoading(true);

    try {
      const args = {
        un: authenticated.un,
        al: authenticated.al
      };
      const response = await PSO.getCollectionListByOwner(args);

      if (response.result === 'success' && response.its) {
        setCampaignsData(response.its);
        setShowLoadMore(response.its.length === 25);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, toggleLoading, setCampaignsData, setShowLoadMore]);

  const loadMoreCollections = useCallback(async () => {
    if (campaignsData && campaignsData.length > 0) {
      const lastElement = campaignsData[campaignsData.length - 1];
      if (lastElement && lastElement.colid) {
        const lastId = lastElement.colid;

        toggleLoading(true);

        try {
          const args = {
            un: authenticated.un,
            al: authenticated.al,
            lastId: lastId
          };

          const response = await PSO.getCollectionListByOwner(args);

          if (response.result === 'success' && response.its) {
            setCampaignsData([...campaignsData, ...response.its]);
            setShowLoadMore(response.its.length === 25);
          } else {
            const message = (response && response.error) ? response.error : Strings('error_on_request');
            toast.error(message);
          }

          toggleLoading(false);
        } catch (err) {
          toast.error(Strings('general_error'));
          toggleLoading(false);
        }
      }
    }
  }, [campaignsData, authenticated, toggleLoading]);

  useEffect(() => {
    getCollections();
  }, [getCollections]);

  return (
    <Fragment>
      {campaignsData && campaignsData.length === 0 && (
        <div className="mt-2 alert alert-info fade show" role="alert">
          {Strings('no_registered_campaigns')}
        </div>
      )}

      <Card className='main-card mb-2'>
        <ListGroup>
          {campaignsData && campaignsData.length > 0 && campaignsData.map((item, index) => (
            <ListGroupItem key={item.colid}>
              <div className='widget-content p-0'>
                <div className='widget-content-wrapper'>
                  <div className='widget-content-left'>
                    <div className='widget-heading'>
                      {item.coln}
                    </div>
                    {item.cold && (
                      <div className='widget-subheading'>
                        {item.cold}
                      </div>
                    )}
                  </div>
                  <div className='widget-content-right'>
                    <ButtonGroup size='md'>
                      <Button
                        color='primary'
                        onClick={() => goToCampaign(item)}
                      >
                        {Strings('manage')}
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      </Card>
      
      <Row className='mb-3'>
        {showLoadMore && (
          <Col>
            <Button
              color='primary'
              onClick={loadMoreCollections}
            >
              {Strings('load_more')}
            </Button>
          </Col>
        )}
      </Row>
    </Fragment>
  );
}
